import React, { useContext, useEffect, useState } from "react";
import useLocalStorage from "../hooks/useLocalStorage";
import { useSocket } from "./SocketProvider";
import config from "../config.json";
import toast, { Toaster } from "react-hot-toast";
const ContactsContext = React.createContext();

export function useContacts() {
  return useContext(ContactsContext);
}

export function ContactsProvider({ id, children }) {
  const [contacts, setContacts] = useLocalStorage("contacts", []);
  const [refreshContact, setRefreshContact] = useState(true);

  function createContact(id, name, image) {
    setContacts((prevContacts) => {
      return [...prevContacts, { id, name, image }];
    });
  }

  function updateContact(index, id, name, image) {
    setContacts((prevContacts) => {
      const updatedContacts = [...prevContacts];
      updatedContacts[index] = { ...updatedContacts[index], name, image };
      return updatedContacts;
    });
  }

  useEffect(() => {
    (async () => {
      try {
        // const response = await fetch(
        //   config.domainName + ":" + config.port + "/user/getcontacts/?id=" + id,
        //   {
        //     method: "GET",
        //     headers: { "Content-Type": "application/json" },
        //     credentials: "include",
        //   }
        // );

        // const content = await response.json();
        // console.log(content);
        // content.contacts.forEach((contact) => {
        //   // check if the contact already exists in the contacts array
        //   const contactExists = contacts.some(
        //     (existingContact) => existingContact.id === contact["user id"]
        //   );
        //   if (!contactExists) {
        //     // create a new contact using the createContact function
        //     createContact(contact["user id"], contact.nickname, contact.image);
        //   }
        // });
        const response = await fetch(
          config.domainName + ":" + config.port + "/user/all",
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );

        const content = await response.json();
        console.log(content);
        content.users.forEach((contact) => {
          // check if the contact already exists in the contacts array

          const existingContactIndex = contacts.findIndex(
            (existingContact) => existingContact.id === contact.id
          );

          if (existingContactIndex !== -1) {
            // If the contact already exists, update its data
            const existingContact = contacts[existingContactIndex];
            if (
              existingContact.name !== contact.name ||
              existingContact.image !== contact.image
            ) {
              // If the contact's data has changed, update it
              updateContact(
                existingContactIndex,
                contact["id"],
                contact.name,
                contact.image
              );
            }
          } else {
            // create a new contact using the createContact function
            createContact(contact["id"], contact.name, contact.image);
          }
        });
      } catch (error) {
        console.log("Server can not be connected");

        // toast.error(
        //   "Server can not be connected!",
        //   `{
        //   id: "error",
        //   duration: Infinity,
        // }`
        // );
      }
    })();
  }, [id, refreshContact]);

  return (
    <ContactsContext.Provider
      value={{ contacts, createContact, setRefreshContact }}
    >
      <Toaster />
      {children}
    </ContactsContext.Provider>
  );
}
